// ─────────────────────────────────────────────────────────────
//  Add these to your existing homeSlice.js  (or a new moviesSlice)
// ─────────────────────────────────────────────────────────────
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiClient from "../config/apiClient";
import API_ENDPOINTS from "../config/api";

// ── Thunks ──────────────────────────────────────────────────

export const fetchAllMovies = createAsyncThunk(
  "movies/fetchAllMovies",
  async (page = 1, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(
        `${API_ENDPOINTS.LIST_MOVIES}?page=${page}`
        // e.g.  http://localhost:3000/api/list/movies/all?page=1
      );
      return res.data; // { data, current_page, total_pages, total, per_page }
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchAllTvShows = createAsyncThunk(
  "movies/fetchAllTvShows",
  async (page = 1, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(
        `${API_ENDPOINTS.LIST_TV_SHOWS}?page=${page}`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

// ── Slice ────────────────────────────────────────────────────

const moviesSlice = createSlice({
  name: "movies",
  initialState: {
    // Movies listing
    all_movies:              [],
    all_movies_loading:      false,
    all_movies_error:        null,
    all_movies_current_page: 1,
    all_movies_total_pages:  1,
    all_movies_total:        0,

    // TV Shows listing
    all_tv_shows:              [],
    all_tv_shows_loading:      false,
    all_tv_shows_error:        null,
    all_tv_shows_current_page: 1,
    all_tv_shows_total_pages:  1,
    all_tv_shows_total:        0,
  },
  reducers: {},
  extraReducers: (builder) => {
    // ── All Movies ──
    builder
      .addCase(fetchAllMovies.pending, (state) => {
        state.all_movies_loading = true;
        state.all_movies_error   = null;
      })
      .addCase(fetchAllMovies.fulfilled, (state, action) => {
        state.all_movies_loading      = false;
        state.all_movies              = action.payload.data;
        state.all_movies_current_page = action.payload.current_page;
        state.all_movies_total_pages  = action.payload.total_pages;
        state.all_movies_total        = action.payload.total;
      })
      .addCase(fetchAllMovies.rejected, (state, action) => {
        state.all_movies_loading = false;
        state.all_movies_error   = action.payload;
      })

    // ── All TV Shows ──
      .addCase(fetchAllTvShows.pending, (state) => {
        state.all_tv_shows_loading = true;
        state.all_tv_shows_error   = null;
      })
      .addCase(fetchAllTvShows.fulfilled, (state, action) => {
        state.all_tv_shows_loading      = false;
        state.all_tv_shows              = action.payload.data;
        state.all_tv_shows_current_page = action.payload.current_page;
        state.all_tv_shows_total_pages  = action.payload.total_pages;
        state.all_tv_shows_total        = action.payload.total;
      })
      .addCase(fetchAllTvShows.rejected, (state, action) => {
        state.all_tv_shows_loading = false;
        state.all_tv_shows_error   = action.payload;
      });
  },
});

export default moviesSlice.reducer;